// extracted by mini-css-extract-plugin
export default {"container":"Layout-module--container--2IpcU","header":"Layout-module--header--2872K","footer":"Layout-module--footer--3r6XS","main":"Layout-module--main--2xgBs"};